import { render, staticRenderFns } from "./contact-manage.vue?vue&type=template&id=0ced8570"
import script from "./contact-manage.vue?vue&type=script&lang=js"
export * from "./contact-manage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports